import client from "./client";
import { metaClickIds } from "../lib/metaClickIds";

export const authApi = {
  // The click ids ride along so the server can report this signup to Meta
  // even when no lead row exists — someone who clicked the ad and signed up
  // in the same browser never left one. The caller's payload wins.
  signup: (data) => client.post("/api/auth/signup", { ...metaClickIds(), ...data }),
  login: (data) => client.post("/api/auth/login", data),
  logout: () => client.post("/api/auth/logout"),
  refresh: () => client.post("/api/auth/refresh"),
  // POST, not GET: verifying signs the visitor in, and a GET that mints a
  // session is one any prefetcher or mail-security scanner can fire — burning
  // the single-use token and taking the cookies with it.
  verifyEmail: (token) => client.post("/api/auth/verify-email", { token }),
  resendVerification: (email) => client.post("/api/auth/resend-verification", { email }),
  forgotPassword: (email) => client.post("/api/auth/forgot-password", { email }),
  resetPassword: (data) => client.post("/api/auth/reset-password", data),
  googleLogin: () => {
    window.location.href = `${client.defaults.baseURL}/api/auth/oauth/google`;
  },
  passkeyLoginStart: () => client.post("/api/auth/passkey/login/start"),
  passkeyLoginComplete: (data) => client.post("/api/auth/passkey/login/complete", data),
  passkeyRegisterStart: () => client.post("/api/auth/passkey/register/start"),
  passkeyRegisterComplete: (data) => client.post("/api/auth/passkey/register/complete", data),
  passkeySignupStart: (data) => client.post("/api/auth/passkey/signup/start", data),
  passkeySignupComplete: (data) => client.post("/api/auth/passkey/signup/complete", data),
  passkeyList: () => client.get("/api/auth/passkey/list"),
  deletePasskey: (id) => client.delete(`/api/auth/passkey/${id}`),
};
